export default "__VITE_ASSET__Tjq2Yyvt__"